module.exports = __webpack_public_path__ + "img/aeroland-pricing-image-06.048dddd5.png";